import { render, staticRenderFns } from "./NodeDeleteButton.vue?vue&type=template&id=671ac08e&lang=pug&"
import script from "./NodeDeleteButton.vue?vue&type=script&lang=js&"
export * from "./NodeDeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports